export default function List({ data, onWeChatClick }) {
  const handleAddressClick = (address) => {
    window.open(
      `https://www.google.com/maps/search/?api=1&query=${address}`,
      "_blank"
    );
  };

  const sanitizePhoneNumber = (input) => {
    if (!input) return "";
    const cleaned = input.replace(/[^\d+]/g, "");
    return cleaned.replace(/(?!^)[+]/g, "");
  };

  const isPhoneNumber = (input) => {
    if (!input || typeof input !== "string") return false;
    const digitsOnly = input.replace(/\D/g, "");
    return digitsOnly.length >= 7;
  };
  return (
    <div className={`flex flex-col text-pure-white gap-2.5 3xl:gap-5`}>
      <span className="font-bold text-[18px]">{data.key}</span>

      <div
        className={`${
          data?.key?.toLowerCase().includes("social")
            ? "grid grid-cols-2 lg:flex lg:flex-col gap-[12px]"
            : "flex flex-col gap-[12px]"
        }`}
      >
        {data?.links &&
          data?.links?.length > 0 &&
          data?.links?.map((link, index) => (
            <div key={index} className="flex flex-col gap-[2px]">
              {link?.label && (
                <h3 className="text-[12px] font-medium text-pure-white/50">
                  {link?.label}
                </h3>
              )}
              <div
                className="w-max flex items-center gap-2 group cursor-pointer"
                onClick={() => {
                  const text = link?.text;
                  const labelLower = (link?.label || "").toLowerCase();

                  if (
                    text?.toLowerCase().includes("wechat") ||
                    text?.toLowerCase().includes("we chat")
                  ) {
                    if (onWeChatClick) {
                      onWeChatClick();
                      return;
                    }
                  }

                  if (labelLower === "address" && text) {
                    handleAddressClick(text);
                    return;
                  }

                  if (text && isPhoneNumber(text)) {
                    const tel = sanitizePhoneNumber(text);
                    if (tel) {
                      window.location.href = `tel:${tel}`;
                      return;
                    }
                  }

                  if (link?.link) {
                    // if (link?.text?.toLowerCase() === "cambridge") {
                    //   window.open(
                    //     "https://www.therailyard.co.uk/student-accommodation/cambridge/?__hstc=205965068.2cebfa8e1154a0eba4ecad667db77332.1743605731780.1759728640995.1759740540808.35&__hssc=205965068.3.1759740540808&__hsfp=4090584363",
                    //     "_blank"
                    //   );
                    // } else {
                    window.open(link?.link, "_blank");
                    //}
                  }
                }}
              >
                {link?.icon && (
                  <img
                    src={link?.icon?.url}
                    alt={link?.text}
                    className="w-[24px] h-[24px]"
                  />
                )}

                <button className="lg:hover:underline underline-offset-2 lg:hover:text-secondary-rectangle-one text-[12px] lg:text-[14px] font-normal shrink-0">
                  {link.text}
                </button>
              </div>
            </div>
          ))}
      </div>
    </div>
  );
}
